import axios from 'axios';
import {ordersServicesPath} from '../../../../Constants';

const cuttingMapDataObjectRestUrl =
    ordersServicesPath + '/organizations/cutting-map-data-objects';

export default class CuttingMapDataObjectService {
    /**
     * JSON дерева карты раскроя (CuttingMap) для векторной отрисовки.
     * @param {number|string} id cuttingMapDataObject.id
     */
    static async getJson(id) {
        return axios.get(`${cuttingMapDataObjectRestUrl}/${id}/get-json`, {
            headers: {
                'Content-Type': 'application/json',
            },
        });
    }
}
